import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8cc3e40e")

_pushScopeId("data-v-8cc3e40e")
const _hoisted_1 = { class: "card-body pt-0" }
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = { class: "table table-row-dashed align-middle gs-0 gy-4" }
const _hoisted_4 = { class: "fw-bolder text-muted tableOpacity" }
const _hoisted_5 = { class: "w-120px" }
const _hoisted_6 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "120",
  height: "18"
}, null, -1)
const _hoisted_7 = { class: "min-w-400px" }
const _hoisted_8 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "320",
  height: "18"
}, null, -1)
const _hoisted_9 = { class: "min-w-250px" }
const _hoisted_10 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "200",
  height: "18"
}, null, -1)
const _hoisted_11 = { class: "w-120px" }
const _hoisted_12 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "120",
  height: "18"
}, null, -1)
const _hoisted_13 = { class: "w-120px" }
const _hoisted_14 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "120",
  height: "18"
}, null, -1)
const _hoisted_15 = { class: "w-100px py-5" }
const _hoisted_16 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "100",
  height: "18"
}, null, -1)
const _hoisted_17 = { class: "min-w-400px py-5" }
const _hoisted_18 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "320",
  height: "18"
}, null, -1)
const _hoisted_19 = { class: "min-w-250px py-5" }
const _hoisted_20 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "200",
  height: "18"
}, null, -1)
const _hoisted_21 = { class: "w-100px py-5" }
const _hoisted_22 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "100",
  height: "18"
}, null, -1)
const _hoisted_23 = { class: "w-100px py-5" }
const _hoisted_24 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "100",
  height: "18"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_content_loader = _resolveComponent("content-loader")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("table", _hoisted_3, [
        _createVNode("thead", null, [
          _createVNode("tr", _hoisted_4, [
            _createVNode("th", _hoisted_5, [
              _createVNode(_component_content_loader, {
                class: "content-loader-full",
                width: 120,
                height: 18,
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _createVNode("th", _hoisted_7, [
              _createVNode(_component_content_loader, {
                class: "content-loader-full",
                width: 400,
                height: 18,
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _createVNode("th", _hoisted_9, [
              _createVNode(_component_content_loader, {
                class: "content-loader-full",
                width: 250,
                height: 18,
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _createVNode("th", _hoisted_11, [
              _createVNode(_component_content_loader, {
                class: "content-loader-full",
                width: 120,
                height: 18,
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_12
                ]),
                _: 1
              })
            ]),
            _createVNode("th", _hoisted_13, [
              _createVNode(_component_content_loader, {
                class: "content-loader-full",
                width: 120,
                height: 18,
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createVNode("tbody", null, [
          (_openBlock(), _createBlock(_Fragment, null, _renderList(10, (index) => {
            return _createVNode("tr", {
              key: index,
              class: "tableOpacity"
            }, [
              _createVNode("td", _hoisted_15, [
                _createVNode(_component_content_loader, {
                  class: "content-loader-full",
                  width: 100,
                  height: 18,
                  speed: 2,
                  primaryColor: "#ababab",
                  secondaryColor: "#cccccc"
                }, {
                  default: _withId(() => [
                    _hoisted_16
                  ]),
                  _: 1
                })
              ]),
              _createVNode("td", _hoisted_17, [
                _createVNode(_component_content_loader, {
                  class: "content-loader-full",
                  width: 400,
                  height: 18,
                  speed: 2,
                  primaryColor: "#ababab",
                  secondaryColor: "#cccccc"
                }, {
                  default: _withId(() => [
                    _hoisted_18
                  ]),
                  _: 1
                })
              ]),
              _createVNode("td", _hoisted_19, [
                _createVNode(_component_content_loader, {
                  class: "content-loader-full",
                  width: 250,
                  height: 18,
                  speed: 2,
                  primaryColor: "#ababab",
                  secondaryColor: "#cccccc"
                }, {
                  default: _withId(() => [
                    _hoisted_20
                  ]),
                  _: 1
                })
              ]),
              _createVNode("td", _hoisted_21, [
                _createVNode(_component_content_loader, {
                  class: "content-loader-full",
                  width: 100,
                  height: 18,
                  speed: 2,
                  primaryColor: "#ababab",
                  secondaryColor: "#cccccc"
                }, {
                  default: _withId(() => [
                    _hoisted_22
                  ]),
                  _: 1
                })
              ]),
              _createVNode("td", _hoisted_23, [
                _createVNode(_component_content_loader, {
                  class: "content-loader-full",
                  width: 100,
                  height: 18,
                  speed: 2,
                  primaryColor: "#ababab",
                  secondaryColor: "#cccccc"
                }, {
                  default: _withId(() => [
                    _hoisted_24
                  ]),
                  _: 1
                })
              ])
            ])
          }), 64))
        ])
      ])
    ])
  ]))
})